export default __webpack_public_path__ + "static/media/m2.02e28118.jpg";